import { IconButton } from "@mui/material";
import { closeSnackbar, type SnackbarKey } from "notistack";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";

/** Botão de fechar padrão dos snackbars (notistack), reutilizado em toda a aplicação. */
export const SnackbarCloseAction = (snackbarId: SnackbarKey) => (
	<IconButton size="small" aria-label="close" color="inherit" onClick={() => closeSnackbar(snackbarId)}>
		<FuseSvgIcon size={18} color="inherit">
			lucide:x
		</FuseSvgIcon>
	</IconButton>
);
